import * as React from 'react';
import * as I18n from 'i18n-js';
import UrlHelpers from './shared/url_helpers';

interface Props {
  hasAdyenBankAccount: boolean;
}

export default function MarketpayPayouts({ hasAdyenBankAccount }: Props) {
  return (
    <div className="scaling-mb-2">
      <div className="payment-setup">
        <div className="payment-setup__info">
          <MarketpayPayoutActions hasAdyenBankAccount={hasAdyenBankAccount} />
        </div>
      </div>
    </div>
  );
}

function MarketpayPayoutActions({ hasAdyenBankAccount }: { hasAdyenBankAccount: boolean }) {
  if (hasAdyenBankAccount) {
    return (
      <a href={UrlHelpers.coreBankAccountPath} className="button">
        {I18n.t('discovery.payoutMethod.editBankAccount')}
      </a>
    );
  }

  return (
    <div className="alert alert-info">
      <p className="heading-4">
        {I18n.t('discovery.payoutMethod.completeSetupCta.title')}
      </p>
      <p>
        {I18n.t('discovery.payoutMethod.completeSetupCta.completeDetails')}
      </p>
      <a href={UrlHelpers.shopOnboardingSetupPath} className="button button--blue mt-2">
        {I18n.t('discovery.payoutMethod.completeSetupCta.buttonText')}
      </a>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/marketpay_payouts.tsx